
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import cusDateTime from '@/components/cusDateTime';
import {openMap} from '@/utils/commons';
export default {
name: "new-delivery",
components:{Swiper,SwiperItem,cusDateTime},
data(){
return{
orderNo:null,
asn:{
createdPersonType:'1',
attachment:{},
status: 'TO_BE_RECEIVED',
driStatus:'DELIVERY',
shipMethod:'SELF_DELIVER',
expDelDate:dateFormat(new Date(),'YYYY-MM-DD'),
expArrDate:dateFormat(new Date(),'YYYY-MM-DD')
},
selectModel:'base',
showImgBol:false,
showImgSrc:'',
imgList:[],
driverId:null,
imgBaseUrl:process.env.API_ROOT,
purOrder:{}
}
},
methods:{
backMyDriver(){
this.$router.replace('/driver/my-delivery');
},
changeShowModel(str){
this.selectModel = str;
},
changeShow(data){
if(data.cellShow){
this.$set(data,'cellShow',false);
return;
}
this.$set(data,'cellShow',true);
},
showImg(item){
this.showImgSrc = item;
this.showImgBol = true;
},
closeImg(){
this.showImgBol = false;
},
copyAdd() {
let textareaEl = document.createElement('textarea');
textareaEl.setAttribute('readonly', 'readonly'); 
textareaEl.value = this.asn.shipAddress;
document.body.appendChild(textareaEl);
textareaEl.select();
document.execCommand('copy');
document.body.removeChild(textareaEl);
this.$vux.toast.text('复制成功');
},

viewMap() {
if (this.asn.shipAddress) {
openMap(this.asn.shipAddress);
}
},
getOrderDetail(){
this.$loadingShow();
let obj = {
direction: "ASC",
fromClientType: "pc",
ignoreField: true,
number: 0,
property: "requireGoodsDateFrom",
rules:[
{
collectIndex: -1,
field: "orderNo",
option: "IN",
values: [this.orderNo]
}
],
size:100
};
if (this.$route.params.codeType === 'erpCode') {
obj.rules[0].field = "purOrderDetail.purOrder.orderNoERP";
}
this.$post('api/asn-dt/need/page',obj).then((res) => {
if(res.content && res.content.length){
if(res.content[0].purOrderId){
this.$get(`api/purOrder/${res.content[0].purOrderId}`).then((pur) => {
this.purOrder = pur;
})
}
res.content.forEach(item => {
item.poNo = item.orderNo;
item.poItemNo = item.purOrderDetail.itemNo;
item.deliveryDate = item.requireGoodsDateFrom;
item.requireQty = item.confirmCount;
item.supplier = {
id:item.supplierId,
supplierCode:item.supplierCode,
supplierName:item.supplierName
};
if(item.purOrderDetail.material != null){
item.material = item.purOrderDetail.material;
}
item.materialName = item.purOrderDetail.matName;
item.unit = item.purOrderDetail.orderUnit;
item.checked = false;
if (item.planType == 'confirm') {
item.requireGoodsPlanRow = { id: item.id };
}
item.sourceId = item.id;
item.requireGoodsPlanRow = {id:item.id,planType: item.planType };
delete item.id;
});
this.asn.plant = res.content[0].plant;
this.asn.shipAddress = res.content[0].shipAddress;
this.asn.supplier = res.content[0].supplier;
this.asn.orderDetails = res.content;
this.asn.orderDetails.sort((a1,a2) => {
return a1.poItemNo - a2.poItemNo;
});
this.asn.orderDetails.filter(item => !item.deleted);
let num = 1;
this.asn.orderDetails.forEach((item) => {
item.itemNo = num + '0';
num++;
item.delQty = item.maxQty;
})
}
this.asn = Object.assign({},this.asn);
this.imgList = [];
if(this.asn.plant && this.asn.plant.attachment && this.asn.plant.attachment.attachFile){
this.asn.plant.attachment.attachFile.forEach((item) => {
let str = this.imgBaseUrl + 'api/file/download/' + item.key;
this.imgList.push(str);
})
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
getCurrent(){
this.$get('api/person/current').then((res) => {
this.asn.consignor = res.name;
this.asn.consignorTel = res.login;
this.asn.carrier = res.name;
this.asn.carrierTel = res.login;
this.asn.founderId = res.id;
this.asn.founderName = res.name;
this.asn = Object.assign({},this.asn);
this.$get(`api/driver/tel/${res.login}`).then((val) =>{
this.driverId = val.id;
this.asn.carrierId = this.driverId;
this.$set(this.asn,'carNumber',val.carNumber);
})
})
},
submit(){
let list = [];
for(let i=0;i<this.asn.orderDetails.length;i++){
if(this.asn.orderDetails[i].delQty){
let qty = this.asn.orderDetails[i].requireQty - this.asn.orderDetails[i].asnCrtQty - this.asn.orderDetails[i].asnReceiveQty;
if(this.asn.orderDetails[i].delQty > qty ){
this.$vux.toast.text(`第${i+1}行明细的送货数量不应大于${qty}`);
return;
}
list.push(this.asn.orderDetails[i]);
}
}
if(!list.length){
this.$vux.toast.text('请至少补充一条明细的送货数量');
return;
}
this.$vux.confirm.show({
title: `是否确认创建${list.length}条送货明细？`,
onConfirm:() => {
let obj = JSON.parse(JSON.stringify(this.asn));
obj.orderDetails = list;
obj.expDelDate = new Date(this.asn.expDelDate);
obj.expArrDate = new Date(this.asn.expArrDate);
this.$loadingShow();
this.$post('api/asn',obj).then((res) => {
this.$vux.toast.text('送货单创建成功');
this.$router.replace('/driver/my-delivery');
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
}
});
}
},
mounted(){
this.orderNo = this.$route.params.orderNo;
this.getOrderDetail();
this.getCurrent();
}
}



// WEBPACK FOOTER //
// ./src/page/driver/new-delivery.vue